// pages/PasswordResetInfo.jsx
import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import '../styles/SetPassword.css'

const PasswordResetInfo = () => {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const ticket = params.get('ticket')

  if (!ticket) {
    return (
      <div className="setpassword-right">
        <div className="setpassword-wrapper">
          <div className="setpassword-card">
            <h2 className="setpassword-title">Invalid or Missing Reset Link</h2>
            <p className="setpassword-subtext">Please try requesting a new link from the Forgot Password page.</p>
            <button className="setpassword-button" onClick={() => navigate('/forgot-password')}>Back to Forgot Password</button>
          </div>
        </div>
      </div>
    )
  }

  const handleContinue = () => {
    navigate(`/set-password?ticket=${encodeURIComponent(ticket)}`)
  }

  return (
    <div className="setpassword-right">
      <div className="setpassword-wrapper">
        <div className="setpassword-card">
          <h2 className="setpassword-title">Almost There!</h2>
          <p className="setpassword-subtext">We've confirmed your reset link. Click below to set a new password.</p>
          <button className="setpassword-button" onClick={handleContinue}>
            Set New Password
          </button>
        </div>
      </div>
    </div>
  )
}

export default PasswordResetInfo
